import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IBankMeta } from "../../api/interface"

type ISetSBPSlice = {
  bankVariants: IBankMeta[]
}

const initialState: ISetSBPSlice = {
  bankVariants: [],
}

const settingsSBPSlice = createSlice({
  name: "settingsSBPForm",
  initialState,
  reducers: {
    setBankVariant: (state, action: PayloadAction<IBankMeta>) => {
      const selectedBank = action.payload

      state.bankVariants = [
        ...state.bankVariants.filter(
          (bank) => bank.bankId !== selectedBank.bankId,
        ),
        selectedBank,
      ]
    },
    setBankVariants: (state, action: PayloadAction<IBankMeta[]>) => {
      state.bankVariants = action.payload
    },
    removeBankVariant: (state, action: PayloadAction<string>) => {
      const removedBankId = action.payload

      state.bankVariants = [
        ...state.bankVariants.filter((bank) => bank.bankId !== removedBankId),
      ]
    },
    resetSlice: () => initialState,
  },
})

export const {
  setBankVariant,
  resetSlice,
  setBankVariants,
  removeBankVariant,
} = settingsSBPSlice.actions

export default settingsSBPSlice.reducer
